import React from 'react'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'
import { LinkButton } from '../../../../../components/Button/LinkButton'
import { Button } from '../../../../../components/Button/Button'
import { useAutoMeetingPrep } from '../../../../../views/Setup/Settings/AutoMeetingPrep/hooks'
import { useCookies } from 'react-cookie'

const HIDE_AUTO_MEETING_PREP_CTA_COOKIE_NAME = 'hideAutoMeetingPrepCta'
const HIDE_AUTO_MEETING_PREP_CTA_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export const AutoMeetingPrepPromo: React.FC = () => {
  const [cookies, setCookie] = useCookies([HIDE_AUTO_MEETING_PREP_CTA_COOKIE_NAME])

  const { autoMeetingPrepQuotaEnabled, hasWorkflowUpdateScope, autoMeetingPrepWorkflow, autoMeetingPrepLoading } = useAutoMeetingPrep()

  const handleClickDismissAutoMeetingPrep = () => {
    setCookie(HIDE_AUTO_MEETING_PREP_CTA_COOKIE_NAME, true, { path: '/', maxAge: HIDE_AUTO_MEETING_PREP_CTA_COOKIE_MAX_AGE })
  }

  if (autoMeetingPrepLoading || autoMeetingPrepWorkflow || cookies[HIDE_AUTO_MEETING_PREP_CTA_COOKIE_NAME]) {
    return <div />
  }

  return (
    <div className='d-flex gap-3 m-1 py-3 zocks-px-0.75 align-items-center zocks-bg-color-white border border-1 zocks-border-color-primary zocks-border-0.25'>
      <i className='bi bi-stopwatch fs-5 ps-2' />
      <div className='d-flex zocks-gap-2'>
        <div className='d-flex flex-column gap-2'>
          <div className='paragraph-medium'>
            <strong>Stop preparing meetings manually.</strong> Your AI Assistant generates Meeting Preps automatically before every meeting. Set it up once and
            you're always prepared.
          </div>
          {!hasWorkflowUpdateScope ? (
            <div className='paragraph-medium'>
              <strong>
                {autoMeetingPrepQuotaEnabled
                  ? 'Reach out to your Account Owner to enable Automatic Meeting Prep generation.'
                  : 'Available in Professional plan. Reach out to your Account Owner to request a trial.'}
              </strong>
            </div>
          ) : null}
        </div>
        <div className='d-flex gap-3 align-items-center'>
          {hasWorkflowUpdateScope ? (
            <div>
              <ScopedBlock
                quota={{
                  quota: 'workflow.autoMeetingPrep.value',
                }}
                missingScopeAction={MissingScopeAction.UPGRADE}
              >
                <LinkButton variant='primary' className='button-small py-2 px-3' to='/workspace/setup/settings' target='_blank'>
                  Enable
                </LinkButton>
              </ScopedBlock>
            </div>
          ) : null}
          <div>
            <Button className='px-2' onClick={handleClickDismissAutoMeetingPrep}>
              <i className='bi bi-x-lg' />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
